module.exports = __webpack_public_path__ + "img/hezuokehu.a0ce472c.png";